import Row from "../../atoms/Row";
import styled from "styled-components";
import { device } from "../../../theme";

export const IconsContainer = styled(Row)`
  position: absolute;
  top: 20px;
  width: calc(100vw - 90px);
  padding: 0px 45px;
  justify-content: center;

  @media ${device.tablet} {
    justify-content: flex-end;
  }
`;

export const IconContainer = styled.div`
  width: 50px;
`;
